export default __webpack_public_path__ + "static/media/survey-reports-icon.dc468e4e.svg";